<script>
import { CompareValue } from '@/mixins/component/validateText.js';
import { ValidateRules } from '@/setup/validateControl.js';

export default {
  name: 'MsBaseComponent',
  props: {
    /**
     * rule dùng để validate control
     */
    rules: {
      type: Array,
      validator(value) {
        if (value.length) {
          return value.every((item) => {
            // name phải là các tên đc định nghĩa trong ValidateRules
            if (
              (item.name !== undefined && !ValidateRules[item.name]) ||
              (item.name === ValidateRules.custom && typeof item.customValidate !== 'function') // Nếu là custom thì phải cung cấp hàm custom
            ) {
              console.warn("name phải là các tên đc định nghĩa trong ValidateRules");
              return false;
            }
            // compareValue phải là các tên đc định nghĩa trong CompareValue nếu item.name = ValidateRules.pattern
            if (
              item.compareValue !== undefined &&
              item.name === ValidateRules.pattern &&
              !CompareValue[item.compareValue]
            ) {
              console.warn("compareValue phải là các tên đc định nghĩa trong CompareValue nếu item.name = ValidateRules.pattern");
              return false;
            }
            // customValidate phải là function
            if (
              item.customValidate !== undefined &&
              typeof item.customValidate !== 'function'
            ) {
              console.warn("customValidate phải là function");
              return false;
            }
            // isValidateWhenOutFocus là null, undefined hoặc boolean
            if (
              item.isValidateWhenOutFocus !== undefined &&
              item.isValidateWhenOutFocus !== null &&
              typeof item.isValidateWhenOutFocus !== 'boolean'
            ) {
              console.warn("isValidateWhenOutFocus là null, undefined hoặc boolean");
              return false;
            }
            return true;
          });
        }
        return true;
      },
      default: () => [],
    },
    /**
     * Tên của control phục vụ việc hiện thị message cho validate
     * Created by LTDAT(22.06.2020)
     */
    name: {
      default: null,
      type: String,
    },
    /**
     * Id xác định component
     */
    componentId: {
      type: String,
      default: null,
    },
    /**
     * NNLAM 22/03/2021
     * prop kiểu hàm cho phép custom validate trên cell grid
     */
    customValidateRules: {
      type: Function,
      default: null,
    },
    /**
     * thuộc tính readOnly cho các form sử dụng có thể khai báo trực tiếp
     * Ko cho phép nhập nhưng vẫn đc validate
     */
    readOnly: {
      type: Boolean,
      default: false,
    },

    /**
     * Thuộc tính disable control (bổ sung lên đây để dùng chung cho toàn bộ các component)
     */
    disabled: {
      type: Boolean,
      default: false,
    },

    /**
     * label control - có thể k gán mà chỉnh ở ngoài cho link động
     */
    label: {
      default: null,
      type: String,
    },
    isGridEditor: {
      default: false,
      type: Boolean,
    },
    errorProvider:{
      default:{}
    },

  },
};
</script>
<style lang="scss" scoped></style>
